import { useEffect, useState } from "react";

export const useShiftControl = () => {
  // Allows components to listen for shift button presses

  const [shiftDown, setShiftDown] = useState(false);

  useEffect(() => {
    const onShiftDown = function (e) {
      if (e?.keyCode === 16) {
        // if shift key pressed
        setShiftDown(true);
      }
    };

    const onShiftUp = function (e) {
      if (e?.keyCode === 16) {
        // if shift key pressed
        setShiftDown(false);
      }
    };

    document.addEventListener("keydown", onShiftDown);
    document.addEventListener("keyup", onShiftUp);

    return () => {
      document.removeEventListener("keydown", onShiftDown);
      document.removeEventListener("keyup", onShiftUp);
    };
  }, []);

  return [shiftDown];
};
